<template>
    <footer class="footer bg-primary text-light pt-4">
        <div class="container">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4">
                <div class="col pt-3">
                    <h2 class="h5 footer-heading text-white">HelpDesk</h2>
                    <div class="footer-list">
                        <a-icon icon="Phone" />
                        <span v-html="this.$brand.footer.helpDesk.phone"></span>
                    </div>
                    <div class="footer-list mb-3">
                        <a-icon icon="Mail" />
                        <span v-html="this.$brand.footer.helpDesk.mail"></span>
                    </div>
                    <p class="footer-help text-light mb-2">
                        Pon. – Pt. :
                        <br />06:00 – 18:00
                    </p>
                    <p class="footer-help text-light mb-2">
                        Sobota:
                        <br />08:00 – 16:00
                    </p>
                    <p class="footer-help text-light">
                        Niedziela:
                        <br />Nieczynne
                    </p>

                    <p class="footer-help" v-if="isLogged">
                        <button
                            @click="tour.start()"
                            class="js-walkthrough btn btn-outline-white text-white mt-4"
                        >
                            <a-icon icon="Info" />
                            <span class="ml-2">Samouczek</span>
                        </button>
                    </p>
                </div>
                <div class="col pt-3">
                    <h2 class="footer-heading text-white">Informacje</h2>
                    <ul class="list-unstyled footer-list">
                        <!-- temporary disabled for EP -->
                        <!-- <li>
                            <a
                                class="text-light"
                                target="_blank"
                                :href="
                                    this.$brand.footer.regulation.regulationHref
                                "
                            >
                                Regulamin
                            </a>
                        </li>
                        <li>
                            <a
                                class="text-light"
                                href="javascript:;"
                                @click="onPrivacyPolicyClick"
                                >Przetwarzanie danych osobowych</a
                            >
                        </li> -->
                        <li>
                            <span
                                class="footer-link"
                                @click.prevent="
                                    $store.dispatch('openModal', {
                                        component: 'ModalCookies'
                                    })
                                "
                            >
                                {{ this.$brand.cookies.cookiesModalLinkText }}
                            </span>
                        </li>
                        <li v-if="isLogged">
                            <span
                                class="footer-link"
                                @click.prevent="generateLink"
                                >Wygeneruj link
                                <span
                                    v-if="loading"
                                    class="spinner-border spinner-border-sm ml-1"
                                    style="margin-bottom: 2px"
                                ></span>
                            </span>
                        </li>
                        <li v-if="this.$brand.footer.previousPanel">
                            <a
                                class="text-light"
                                target="_blank"
                                :href="this.$brand.footer.previousPanel.href"
                            >
                                {{ this.$brand.footer.previousPanel.title }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col pt-3">
                    <h2 class="sr-only">M/platform</h2>
                    <img
                        class="footer-heading"
                        :src="require(`@/assets/${this.$brand.logo.whiteLogo}`)"
                    />
                    <address
                        class="text-light footer-address"
                        v-html="this.$brand.footer.mainData.address"
                    ></address>
                    <ul class="list-unstyled footer-list">
                        <li
                            v-for="(item, idx) in this.$brand.footer.mainData
                                .links"
                            :key="idx"
                        >
                            <a
                                class="text-light"
                                target="_blank"
                                :href="item.href"
                                >{{ item.title }}</a
                            >
                        </li>
                    </ul>
                </div>
                <div class="col pt-3">
                    <h2 class="footer-heading text-white">Masz pytania?</h2>
                    <div class="footer-list">
                        <a-icon icon="Phone" />
                        <span>
                            <span
                                v-html="this.$brand.footer.contact.phone"
                            ></span>
                        </span>
                    </div>
                    <div class="footer-list">
                        <a-icon icon="Mail" />
                        <span v-html="this.$brand.footer.contact.mail"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-3 mt-5 footer-copyrights text-light">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <span> {{ this.$brand.footer.platformOwner }}</span>
                    </div>
                    <div
                        class="col-12 col-md-6 text-md-right text-center mt-md-0 mt-3"
                    >
                        <span>v{{ version }}</span>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { tour } from '@/walkthroughs/promoAccept'
export default {
    data() {
        return {
            loading: false,
            tour
        }
    },
    computed: {
        isLogged() {
            return this.$store.getters.isLogged
        },
        rowClasses() {
            // add :class="rowClasses" to .row when section "Potrzebujesz pomocy" will be visible
            return this.isLogged
                ? 'row-cols-sm-2 row-cols-lg-4'
                : 'row-cols-md-3'
        },
        version() {
            return process.env.PACKAGE_VERSION
        }
    },
    methods: {
        onPrivacyPolicyClick() {
            this.$store.dispatch('openModal', {
                component: 'PrivacyPolicy'
            })
        },
        generateLink() {
            this.loading = true
            this.$store.dispatch('saveGeneratedLink').then(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.footer-link {
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}
</style>
